export default class FooterMenu {
	constructor(breakpoint = 768) {
		this.breakpoint = breakpoint;
		this.mobileBtn = '.footer-menu__listItem.menu-item-has-children';
		this.mobileSubmenu = '.footer-menu__sub-list';
		this.resizeEvent = null;
		this.toggleMobileLinkEvent = null;
	}

	init() {
		this.resizeEvent = this.hideMobileMenu.bind(this);
		this.toggleMobileLinkEvent = this.toggleMobileLink.bind(this);
		$('body').on('click', this.mobileBtn, this.toggleMobileLinkEvent);
		window.addEventListener('resize', this.resizeEvent, false);
	}

	hideMobileMenu() {
		if (window.innerWidth > this.breakpoint) {
			$(this.menuWrap).removeAttr('style');
			$(this.mobileBtn).removeClass('footer-menu__listItem--open');
			$(this.mobileSubmenu).removeAttr('style');
		}
	}

	toggleMobileMenu() {
		$(this.header).toggleClass('open-menu');
	}

	toggleMobileLink(event) {
		if (!$(event.target).hasClass('menu-item-has-children')) return;

		$(event.currentTarget)
			.toggleClass('footer-menu__listItem--open')
			.find(this.mobileSubmenu)
			.slideToggle(function () {
				$(event.currentTarget).parent();
			});
	}

	destroy() {
		$('body').off('click', this.mobileBtn, this.toggleMobileLinkEvent);

		window.removeEventListener('resize', this.scrollingEvent, false);
	}
}
